export const TASKS_EXPORT_SHEET_NAME = 'Deal Tasks';

export const TASKS_EXPORT_FILE_NAME_SUFFIX = 'tasks';

export const LATEST_COMMENT_COLUMN_WIDTH = 60;

/** Columns in the same order as the Deal Tasks table. `width` is in Excel character units. */
export const TASKS_EXPORT_COLUMNS = [
    { header: 'Activity', width: 40 },
    { header: 'Target', width: 14 },
    { header: 'Date completed', width: 16 },
    { header: 'Assignees', width: 30 },
    { header: 'Status', width: 12 },
    { header: 'Latest comment thread', width: LATEST_COMMENT_COLUMN_WIDTH },
    { header: 'Attachments', width: 13 },
] as const;

/**
 * Height of a task row, in points — one line of text at the default font size. It has to be
 * written explicitly: without it Excel auto-fits the wrapped comment cell and a long thread
 * stretches its row down the page.
 */
export const TASKS_EXPORT_ROW_HEIGHT = 15;

export const TASKS_EXPORT_DATE_NUM_FMT = 'mm/dd/yyyy';

/** Excel rejects a workbook if any cell holds more than this many characters. */
export const EXCEL_MAX_CELL_LENGTH = 32767;

/** Characters Windows and macOS disallow in file names. */
export const FORBIDDEN_FILE_NAME_CHARACTERS = /[\\/:*?"<>|]/g;
